import React from "react";
import { Link } from "react-router-dom";
import Header from "./../../header/header";
import Navvbar from "./../../header/Navvbar";

const Overview = () => {
  // Define which routes you want to disable
  const disabledLinks = [
    "/newPlanEstimate","/newCasePickup","/casesArrive" ,"/creatShipment",
    "/openTryInCases","/toOutsource","/caseEstimates","/undelivarableCases"
  ];

  const isDisabled = (path) => disabledLinks.includes(path);

  // Shared style objects
  const linkStyle = {
    textDecoration: "none",
    color: "#004aad",
  };

  const disabledLinkStyle = {
    textDecoration: "none",
    color: "grey",
    pointerEvents: "none", // disable clicking
    cursor: "not-allowed", // show disabled cursor
    opacity: 0.6,
  };

  const headingStyle = {
    fontSize: "1.1rem",
    fontWeight: "bold",
    marginLeft: "5px",
    marginBottom: "0",
  };

  const paragraphStyle = {
    color: "#6c757d",
    marginLeft: "20px",
    marginTop: "0",
    marginBottom: "0",
  };

  // A small helper component for repeated sections
  const Section = ({ path, title, desc }) => (
    <div className="action">
      <Link
        to={path}
        style={isDisabled(path) ? disabledLinkStyle : linkStyle}
      >
        <h6 style={headingStyle}>{title}</h6>
      </Link>
      <p style={paragraphStyle}>{desc}</p>
    </div>
  );

  return (
    <>
      <Header />
      <Navvbar />
      <br />
      <div style={{ width: "95%", margin: "0 auto", padding: "0px" }}>
        <div className="col-md-10">
          <div className="main-content">
            <h2>Manage Cases</h2>

            <Section path="/accountDetails" title="New Case" desc="Create a new lab case" />
            <Section path="/newPlanEstimate" title="New Case Plan for Estimate" desc="Create a new lab case estimate" />
            <Section path="/newCasePickup" title="New Case Pickup" desc="Request a case pickup without entering details." />
            <Section path="/casesOpened" title="By Month" desc="Browse cases by month" />
            <Section path="/casesArrive" title="To Arrive" desc="View open cases waiting to arrive at the lab" />
            <Section path="/caseship" title="To Ship" desc="View open cases waiting to ship to accounts" />
            <Section path="/creatShipment" title="Create Shipment" desc="View cases eligible for shipping" />
            <Section path="/openTryInCases" title="Open Try-Ins" desc="View open try-in cases" />
            <Section path="/casesOnHold" title="On Hold" desc="View cases on hold" />
            <Section path="/toOutsource" title="To Outsource" desc="View cases who are candidates for outsourcing" />
            <Section path="/caseEstimates" title="Case Plan for Estimate" desc="View case plans by month" />
            <Section path="/openCases" title="Open Cases" desc="View all open cases" />
            <Section path="/undelivarableCases" title="Undeliverable Cases" desc="View undeliverable cases" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
